import {Box, CircularProgress} from "@mui/material";
import {useSelector} from "react-redux";
import {RootState} from "../store/reducers";


const ApiStatusCircle = () => {
    const isFetching = useSelector((state: RootState) => state.app.isFetching);
    const isPosting = useSelector((state: RootState) => state.app.isPosting);
    
    
    return (
      <Box
          className="api-status-circle"
          sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.5,
              minWidth: 24,
              height: 24,
          }}
      >
          {isFetching && (
              <CircularProgress
                  size={22}
                  thickness={5}
                  sx={{ color: '#fff', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.45))' }}
              />
          )}
          {isPosting && (
              <CircularProgress
                  size={22}
                  thickness={5}
                  sx={{ color: '#ffca28', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.45))' }}
              />
          )}
       </Box>
    );
}

export default ApiStatusCircle;
